// extracted by mini-css-extract-plugin
export var centerText = "_f9-8";
export var container = "_f9-0";
export var doughnutContainer = "_f9-7";
export var legend = "_f9-a";
export var legendItemColorDisplay = "_f9-b";
export var legendItemLabel = "_f9-d";
export var legendItemValue = "_f9-c";
export var lg = "_f9-5";
export var maxWidth = "_f9-9";
export var md = "_f9-4";
export var responsive = "_f9-6";
export var sm = "_f9-3";
export var xs = "_f9-2";
export var xxs = "_f9-1";